import { render } from "./BookNow.vue?vue&type=template&id=581d4d86"
import script from "./BookNow.vue?vue&type=script&lang=js"
export * from "./BookNow.vue?vue&type=script&lang=js"

import "./BookNow.vue?vue&type=style&index=0&id=581d4d86&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__